export default "__VITE_ASSET__5n418Hvy__"